import React from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import { Shield, TrendingUp, TrendingDown } from "lucide-react";

function BaselineViolationsDevicesBox({ value, percentage }) {

    const history = useHistory();
    // Logic: Increase (+) in violations is BAD (Danger). Decrease (-) is GOOD (Success).
    const isIncrease = percentage && percentage.includes("+");
    const isDecrease = percentage && percentage.includes("-");

    const onBoxClick = () => {
        history.push('/recentviolations');
    }

    return (
        <div className="col-xl-3 col-sm-6 col-12 d-flex">
            <div className="oct_info-box-v2 variant-violations" onClick={onBoxClick}>
                <div className="oct_info-box-corner-v2"></div>

                <div className="oct_info-box-content-v2">
                    <div className="oct_info-box-text-content-v2">
                        <span className="oct_info-box-title-v2">Total Violations</span>

                        <div data-toggle="tooltip" title="Number of violations">
                            <span className="oct_info-box-number-v2">
                                {typeof value === 'number' ? value : <div className="dot-flashing ml-3 mt-1" />}
                            </span>
                        </div>

                        <div className="oct_info-box-footer-v2">
                            {
                                percentage && isIncrease ? (
                                    <div className="d-flex align-items-center" data-toggle="tooltip"
                                        title={`Number of total violations has increased by ${percentage}%`}>
                                        <TrendingUp className="trend-icon text-danger" />
                                        <span className="trend-text danger">{percentage}%</span>
                                        <span className="trend-label">Since last month</span>
                                    </div>
                                ) : percentage && isDecrease ? (
                                    <div className="d-flex align-items-center" data-toggle="tooltip"
                                        title={`Number of total violations has decreased by ${percentage}%`}>
                                        <TrendingDown className="trend-icon text-success" />
                                        <span className="trend-text success">{percentage}%</span>
                                        <span className="trend-label">Since last month</span>
                                    </div>
                                ) : (
                                    <div className="d-flex align-items-center" data-toggle="tooltip"
                                        title={`Number of total violations didn't change`}>
                                        {/* <Minus className="trend-icon text-info" /> */}
                                        <span className="trend-text info">{percentage || "0%"}</span>
                                        <span className="trend-label">Since last month</span>
                                    </div>
                                )
                            }
                        </div>
                    </div>

                    <div className="oct_info-box-icon-container-v2">
                        <Shield />
                    </div>
                </div>
            </div>
        </div>
    )

}

export default connect()(BaselineViolationsDevicesBox);
